import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';
import { AssetProductCategoryLovComponent } from '../asset-product-category-lov/asset-product-category-lov.component';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { EntityContainer } from 'src/app/tools/models/entityContainer';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { AssetCall } from '../../models/entities/asset-call';
import { AssetTransferService } from '../../services/asset-transfer.service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { PartnerLovComponent } from 'src/app/assabil-admin/components/master-data/partner/partner-lov/partner-lov.component';
import { Field } from 'src/app/tools/models/dtos/field';


@Component({
    selector: 'asset-call-list',
    templateUrl: './asset-call-list.component.html',
    styleUrls: ['./asset-call-list.component.scss']
})


export class AssetCallListComponent extends BasePage2<AssetCall> {

    // Ffilters
    //------------------------------------
    code : string;
    name : string;
    //------------------------------------


    assetCalls: AssetCall[] = [];

    constructor(
        protected toastr                 : ToastrService,
        protected assetTransferService   : AssetTransferService,
        protected router                 : Router,
        protected baseService            : BaseService,
        protected leanUtilsService       : LeanUtilsService, 
        protected location               : Location) {
         super(toastr, router, baseService, leanUtilsService, location);

         this.entityName = 'assetCall';
    }



    initEntityContainer() {
        this.entityContainer = new EntityContainer(AssetCall);
    }

    getRows(): AssetCall[] {
        return this.assetCalls;
    }


    saveRow(row: AssetCall): Promise<AssetCall> {
        return this.assetTransferService.assetCallSave(row);
    }

    loadData() {
        this.assetTransferService.assetCallsGet().then(result => {
            this.assetCalls = result;
            
        }).catch(error => {
            this.showError(error);
        })
    }

    enrichField(field : Field){
        if (field.prop == 'partner.name') {
            field.modal = AssetProductCategoryLovComponent
        }

        if (field.prop == 'assetProductCategory.name') {
            field.modal = PartnerLovComponent;
        }
    }

}
